// extracted by mini-css-extract-plugin
module.exports = {"Quizlist":"QuizList_Quizlist__2k_Kh"};